import React from 'react'
import { connect } from 'react-redux'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { Page } from '../../../components/page/Page'
import { routes } from '../../../constants'
import { actions } from '../crudDinamicoDefinicao.actions'
import { CrudDinamicoDefinicaoForm } from './CrudDinamicoDefinicaoForm'
import _ from 'lodash'
import '../../../index.scss'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  return {
    messages: state.crudCrudDinamicoDefinicaoState.messages,
    record: state.crudCrudDinamicoDefinicaoState.currentRecord,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadById: (oid) => dispatch(actions.loadById(oid)),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
  }
}

class CrudDinamicoDefinicaoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
    }
    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_CRUD_DINAMICO_DEFINICAO}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_CRUD_DINAMICO_DEFINICAO}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_CRUD_DINAMICO_DEFINICAO}`)
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_CRUD_DINAMICO_DEFINICAO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <CrudDinamicoDefinicaoForm
        record={this.props.record}
        messages={this.props.messages}
        setField={this.props.setField}
      />
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CrudDinamicoDefinicaoFormPageContainer)
